import React from 'react';
import Tooltip from 'react-tooltip-lite';

import { ReactComponent as Checkmark } from '../../images/checkmark.svg';
import { PrimaryLink } from '../Common/Links';
import SmartLink from '../Common/SmartLink';
import * as styles from './ShortFeatureListMobile.module.css';

const ShortFeatureListMobile = ({ featureTiers, list, onScrollCta }) => {
  return (
    <div className={styles.container}>
      <div className={styles.featureGrid} style={{ '--tierCount': list?.tiers?.length }}>
        {list?.tiers?.map((tier, i) => {
          return (
            <div key={i} className={styles.tierHeader}>
              <div>
                <h4>{tier.title}</h4>
                <p>{tier.lede}</p>
              </div>
              <div className={styles.featureButton}>
                <PrimaryLink isButton label={tier.ctaLabel} url={tier.ctaUrl} />
                {tier.secondaryCtaLabel && (
                  <SmartLink className={styles.ctaUrl} to={tier.secondaryCtaUrl}>
                    {tier.secondaryCtaLabel}
                  </SmartLink>
                )}
              </div>
            </div>
          );
        })}
      </div>
      <div className={styles.featureGrid}>
        <h4 className={styles.listHeading}>{list?.features?.heading}</h4>
        {list.features.list.map((feature, i) => {
          return (
            <div key={i} className={styles.row}>
              <div>
                {feature.tooltip ? (
                  <Tooltip
                    direction="right"
                    distance={20}
                    arrowSize={10}
                    arrow={true}
                    className={styles.tooltip}
                    content={feature.tooltip}
                  >
                    <p>{feature.title}</p>
                  </Tooltip>
                ) : (
                  <p>{feature.title}</p>
                )}
                {feature.footnote && <p>{feature.footnote}</p>}
              </div>
              <div className={styles.tierList}>
                {featureTiers.map((tier, k) => {
                  return (
                    <div className={styles.tier} key={k}>
                      <div className={styles.tierTitle}>{tier}</div>
                      <div key={k} className={styles.featureMark}>
                        {feature.tiers.indexOf(tier) > -1 && <Checkmark />}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      <div className={styles.rowFooter}>
        <div className={styles.tierHeader}>
          {/*eslint-disable-next-line*/}
          <a href="#" className={styles.ctaUrl} onClick={onScrollCta}>
            {list.tiers[0].footerCtaLabel}
          </a>
        </div>
      </div>
    </div>
  );
};

ShortFeatureListMobile.propTypes = {
  // myProp: PropTypes.string.isRequired
};

export default ShortFeatureListMobile;
